import { ApiService } from '@/api/services/core/ApiService';
import ENDPOINTS from '@/api/endpoints';
import { axiosInstance } from '@/api/axios';
import { TaxModes } from '@/store/types';

export class TaxModesService extends ApiService {
  public getTaxModesList() {
    return axiosInstance.get<TaxModes>(ENDPOINTS.taxModes);
  }
}
